// extracted by mini-css-extract-plugin
export default {"text":"RestoreTrashbinFilesModal__text--Z1vT0"};